import React from "react";
import { useTranslation } from 'react-i18next';

// @ts-ignore
import classNames from 'classnames';
// @ts-ignore
import { Link } from "react-router-dom";
import styled from "styled-components";

import LanguageSelector from "./LanguageSelector";
import Constants from "../../../../data/Constants";


const StyledSidebar = styled.div`
  background-color: #E4002B;
  color: #FFFFFF;
  height: 93vh;
  font-family: 'Mapfre-Bold';

  &.open {
    display: block;
  }

  &.closed {
    display: none;
  }

  & .menu-options {
    display: flex;
    height: 80%;
    flex-direction: column;
    justify-content: center;
  }

  & ul {
    display: flex;
    flex-direction: column;
    height: 40%;
    justify-content: space-between;
    margin: 0;
    padding: 0;
    text-align: center;
  }

  & li {
    cursor: pointer;
    flex: 0 0 auto;
    font-size: 2rem;
    height: 5%;
    min-height: 2rem;
    list-style: none;

    & a {
      color: inherit;
    }
  }
`;

interface SidebarProps {
  isSidebarOpen: boolean,
  setIsSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>,
}

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }: SidebarProps) => {
  const { t } = useTranslation();

  return (
    <StyledSidebar
      className={ classNames({open: isSidebarOpen, closed: !isSidebarOpen}) }
    >
      <div className='menu-options'>
        <ul>
          <li>
            <Link
              to={ Constants.routes.gip }
              onClick={ () => { setIsSidebarOpen(false) } }
            >
              { t('mobileMenu.option1') }
            </Link>
          </li>
          <li>
            <Link
              to={ Constants.routes.rankings }
              onClick={ () => { setIsSidebarOpen(false) } }
            >
              { t('mobileMenu.option2') }
            </Link>
          </li>
          <li>
            <Link
              to={ Constants.routes.bps }
              onClick={ () => { setIsSidebarOpen(false) } }
            >
              { t('mobileMenu.option3') }
            </Link>
          </li>
          <li>
            <Link
              to={ Constants.routes.gipDownload }
              onClick={ () => { setIsSidebarOpen(false) } }
            >
              { t('mobileMenu.option4') }
            </Link>
          </li>
        </ul>
      </div>
      <LanguageSelector />
    </StyledSidebar>
  );
};

export default Sidebar;
